module.exports = __webpack_public_path__ + "static/media/GuildManage.cfd54c21.svg";